import PickListNavbar from "./pick-list-navbar";
import PickListItemsTable from "./pick-list-items-table";
import PickListFooter from "./pick-list-footer";
import { useState } from "react";
import { Form, Formik } from "formik";

const buildItemRows = (itemData = []) =>
  (itemData || []).map((item, index) => {
    const uomDropdown = item?.uom_dropdown || [];
    const defaultUom =
      uomDropdown.find((entry) => entry?.item_id === item?.uom_id) ||
      uomDropdown[0] ||
      null;
    const ratio =
      defaultUom?.alt_quantity && defaultUom?.base_quantity
        ? Number(defaultUom.base_quantity) / Number(defaultUom.alt_quantity)
        : 1;
    const alreadyPicked = !!item?.picked;

    return {
      row_key: `${item?.item_id}-${item?.to_bin_id}-${item?.item_batch_number}-${index}`,
      sott_id: item?.order_id,
      sott_invoice_number: item?.sott_invoice_number,
      item_id: item?.item_id,
      item_code: item?.item_code,
      from_bin_id: item?.to_bin_id,
      bin_location_no: item?.bin_location_no,
      bin_priority: item?.bin_priority,
      item_batch_number: item?.item_batch_number,
      item_exp_date: item?.item_exp_date,
      qty_expected_base: Number(item?.qty_expected) || 0,
      qty_to_pick_base: Number(item?.qty_to_pick) || 0,
      uom_dropdown: uomDropdown,
      uom_id: defaultUom?.item_id ?? null,
      uom_name: item?.uom_name ?? null,
      uom_ratio: ratio,
      actual_qty_picked: alreadyPicked ? String(item?.qty_to_pick ?? "") : "",
      picked: alreadyPicked,
      already_picked: alreadyPicked,
    };
  });

const CreateViewEditPickList = ({
  isClone = false,
  vendorDetails = [],
  itemData = [],
  disabled = false,
  page = "",
  standAlone = false,
  payto,
  shipto,
  pageType,
  transfer = false,
  storeDetails = {},
  pickListId,
  warehouseId,
  initialPickerId = null,
  initialPickerName = "",
  date='',
  status,
}) => {
  const initialFormValues = {
    cmr_code: vendorDetails?.[0]?.cmr_id
      ? {
          label: vendorDetails?.[0]?.cmr_code ?? "",
          value: vendorDetails?.[0]?.cmr_id ?? "",
        }
      : "",
    cmr_name: vendorDetails?.[0]?.cmr_id
      ? {
          label: vendorDetails?.[0]?.cmr_name,
          value: vendorDetails?.[0]?.cmr_id,
        }
      : "",
    cmr_id: vendorDetails?.[0]?.cmr_id,
    cmr_phone_number: vendorDetails?.[0]?.cmr_phone_number ?? "",
    pl_order_date: vendorDetails?.[0]?.created_date,
    pl_pay_to_address: payto || null,
    pl_ship_to_address: shipto || null,
    picker_id: initialPickerId,
    picker_name: initialPickerName,
    pl_remarks: "",
    pl_order_date:date,
    items: buildItemRows(itemData),
  };
  const [initialValue] = useState(initialFormValues);

  return (
    <Formik enableReinitialize={true} initialValues={initialValue}>
      {() => (
        <Form className="h-full">
          <div
            style={{
              height: `calc(100% - 9.5rem)`,
            }}
            className="mx-5 flex flex-col h-full "
          >
            <PickListNavbar
              isClone={isClone}
              pageType={pageType}
              page={page}
              disabled={disabled}
              transfer={transfer}
              standAlone={standAlone}
              storeDetails={storeDetails}
            />

            <PickListItemsTable disabled={disabled} />
          </div>

          <PickListFooter
            disabled={disabled}
            pickListId={pickListId}
            warehouseId={warehouseId}
            page={page}
            status={status}
          />
        </Form>
      )}
    </Formik>
  );
};
export default CreateViewEditPickList;
